<template>
    <div>
        <rkm-data-table
            :disabled-button-search="true"
            :fields="fields"
            :filter="localFilter"
            :repository="repositories.procedimentoRaas"
            :request-params="requestParams"
            :reset-table="resetTable"
            :search-by="localSearchOption"
            :search-table="searchTable"
            :tbody-tr-class="rowClass"
            ref="DataTable"
            sort-by="unidadeNomeFantasia"
        >
            <template v-slot:filters>
                <rkm-form-input
                    placeholder="Digite para buscar"
                    v-model="localFieldFilter"
                    @keyup.native.enter="handleEnterKey"
                >
                    <rkm-input-group-prepend slot="prepend">
                        <rkm-form-select
                            :options="searchOptions"
                            class="m-0"
                            v-model="localSearchOption"
                        />
                    </rkm-input-group-prepend>
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            <rkm-form-checkbox
                                v-model="exibirProcedimentosQueExigemNumeroDeAutorizacaoNaoPreenchidos"
                            >
                                Exibir procedimentos que exigem números de autorização não preenchidos.
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                        <rkm-button
                            :disabled="localFieldFilter || !disabledButtonSearch ? false : true"
                            @click="search"
                            color="primary"
                            class="btn-search"
                        >
                            Buscar
                        </rkm-button>
                        <rkm-button
                            :disabled="!localFieldFilter"
                            @click="clear"
                            class="btn-clear"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-input-group-append>
                </rkm-form-input>
            </template>

            <template v-slot:cell(cidPrincipal)="{ item }">
                <span
                    :title="item.cidPrincipalNome"
                    v-rkm-tooltip.hover
                >
                    {{ item.cidPrincipalCodigo ? formatCid(item.cidPrincipalCodigo) : null }}
                </span>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :title="!item.exportado ? 'Editar' : 'Visualizar'"
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    authorize="update-raas-procedimento"
                >
                    <rkm-icon :icon="!item.exportado ? 'pen' : 'eye'" />
                </rkm-button>

                <rkm-button
                    :disabled="!!item.exportado"
                    @click="handleDestroy(item.id)"
                    color="danger"
                    small
                    title="Excluir"
                    authorize="destroy-raas-procedimento"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <rkm-row class="mt-3">
            <rkm-col>
                <p class="m-0">
                    Linhas em <span class="danger">vermelho</span> representam procedimentos que exigem número de autorização e que não estão preenchidos.
                </p>
            </rkm-col>
        </rkm-row>

        <Modal
            @close="$refs.DataTable.refresh()"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './components/cadastro/Modal.vue'

// Mixins.
import { repository, formats } from '@/mixins'

export default {
    components: { Modal },
    computed: {
        requestParams() {
            return {
                exibir_procedimentos_que_exigem_numero_de_autorizacao_nao_preenchidos: this.exibirProcedimentosQueExigemNumeroDeAutorizacaoNaoPreenchidos
            }
        },
        searchOptions() {
            return this.fields.filter(field => !!field.searchable).map(field => {
                return { text: field.label, value: field.key }
            })
        },
    },
    created() {

        this.repositories = {
            procedimentoRaas: this.getConectaSusRepository('raas.procedimento'),
        }
    },
    data() {
        return {
            disabledButtonSearch: false,
            exibirProcedimentosQueExigemNumeroDeAutorizacaoNaoPreenchidos: false,
            fields: [
                { key: 'unidadeNomeFantasia', name: 'unidade.nomeFantasia', label: 'Unidade', searchable: true, sortable: true },
                { key: 'competenciaValor', name: 'competencia.valor', label: 'Competência', searchable: true, sortable: true },
                {
                    key: 'dataAdmissao',
                    name: 'atendimento.dataAdmissao',
                    label: 'Data de admissão',
                    formatter: v => this.formatDate(v),
                    searchable: true,
                    sortable: true
                },
                { key: 'origemPacienteNome', name: 'origemPaciente.nome', label: 'Origem do paciente', searchable: true, sortable: true },
                { key: 'pacienteNome', name: 'cidadao.nome', label: 'Paciente', searchable: true, sortable: true },
                { key: 'cidPrincipal', name: 'cidPrincipal', label: 'CID principal', searchable: true, sortable: true },
                { key: 'destinoPacienteNome', name: 'destinoPaciente.nome', label: 'Destino do paciente', searchable: true, sortable: true },
                { key: 'numeroAutorizacao', name: 'atendimento.numeroAutorizacao', label: 'Número de autorização', searchable: true, sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ],
            localFieldFilter: null,
            localFilter: null,
            localSearchOption: null,
            resetTable: false,
            searchTable: false,
        }
    },
    methods: {
        refresh() {

            this.$refs.DataTable.refresh()
        },
        handleDestroy(id) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o atendimento e seus procedimentos?',
                () => this.repositories.procedimentoRaas.destroy(id).then(() => this.$refs.DataTable.refresh())
            )
        },
        search() {
            this.searchTable = true
            this.resetTable = false
            this.localFilter = this.localFieldFilter
            this.$refs.DataTable.refresh();
        },
        clear() {
            this.localSearchOption = this.searchBy || this.searchOptions[0].value;
            this.clearSearchOption()
        },
        clearSearchOption() {
            this.localFieldFilter = null
            this.exibirProcedimentosQueExigemNumeroDeAutorizacaoNaoPreenchidos = false
            this.clearTable()
        },
        clearTable() {
            this.localFilter = null
            this.resetTable = true
            this.searchTable = false
        },
        handleEnterKey(event) {
            if (event.key === 'Enter' && (this.localFieldFilter || !this.disabledButtonSearch)) {
                this.search();
            }
        },
        rowClass(item, type) {
            if(item && type === 'row') {
                if (item.temProcedimentoQueExigeNumeroAutorizacaoSemPreenchimento) {
                    return 'table-danger'
                }
            }
        },
    },
    mixins: [repository, formats],
    mounted() {
        if (this.searchOptions.length > 0) {
            this.localSearchOption = this.searchOptions[0].value
        }
    },
    watch: {
        exibirProcedimentosQueExigemNumeroDeAutorizacaoNaoPreenchidos: function () {
            this.clearTable()
        },
        filter(value) {
            this.localFilter = value
        },
        'localSearchOption': function () {
            this.clearSearchOption()
        },
        'localFieldFilter': function (value) {
            this.searchTable = value ? true : false
            this.clearTable()
        },
    },
}
</script>

<style scoped>
.danger {
    color: var(--danger);
}
</style>